import React from "react";
import { Button } from "./ui/button";

export function LoadMore({ remaining, busy, onClick, testId }) {
  if (remaining <= 0) return null;
  return (
    <div className="mt-4 flex justify-center">
      <Button variant="outline" onClick={onClick} disabled={busy} className="rounded-full" data-testid={testId}>
        {busy ? "Loading…" : `Load more (${remaining} remaining)`}
      </Button>
    </div>
  );
}
